jQuery(window).on('load', function() { // makes sure the whole site is loaded
    jQuery('#status').fadeOut(); // will first fade out the loading animation
    jQuery('#preloader').delay(400).fadeOut('slow').remove(); // will fade out the white DIV that covers the website.
    jQuery('body').delay(5000).css({'overflow':'visible'});
});
jQuery(document).ready(function($) {
  if ($(window).width() < 767) {
    if($('.preheadercontainer').length !== 0) {
      $('body').addClass('mobile-view');
      var topbar = $('.preheadercontainer').clone();
      $('.preheadercontainer').remove();
      $('.navigation').append(topbar);
      $('.navigation .preheadercontainer').addClass('mobile');
      $('.navigation .preheadercontainer .call-us').wrap('<li class="menu-item call-us"/>').contents().unwrap();
      var call_us_container = $('.navigation .preheadercontainer .call-us').clone();
      $('.navigation .preheadercontainer .recommend-us').wrap('<li class="menu-item recommend-us"/>').contents().unwrap();
      var recommend_us_container = $('.navigation .preheadercontainer .recommend-us').clone();
      $('.navigation .preheadercontainer .recommend-us').remove();
      var social_nav_container = $('.navigation .preheadercontainer .social-nav').clone();
      $('.navigation .preheadercontainer .social-nav').remove();


      $('.genesis-nav-menu .menu').append(recommend_us_container);
      $('.navigation .preheadercontainer .call-us').remove();
      $('.genesis-nav-menu .menu').append(call_us_container);
      $('.genesis-nav-menu .menu').append(social_nav_container);
      $('.preheaderleft').remove();
    }
  }

  $(".social-area").each(function(index) {
    $(this).next(".navigation").andSelf().wrapAll("<div class='right-header__bottom' />");
  });
  $(".right-header__top").each(function(index) {
    $(this).next(".right-header__bottom").andSelf().wrapAll("<div class='right-header' />");
  });

  // Back To Top Button
  (function($) {
    function setCookie(cookieName,cookieValue,nDays) {
       var today = new Date();
       var expire = new Date();
       if (nDays==null || nDays==0) nDays=1;
       expire.setTime(today.getTime() + 3600000*24*nDays);
       document.cookie = cookieName+"="+escape(cookieValue) + ";expires="+expire.toGMTString();
    }
    function getCookie(cookieName) {
      var value = "; " + document.cookie;
      var parts = value.split("; " + cookieName + "=");
      if (parts.length == 2) return parts.pop().split(";").shift();
    }

    var $scrollTopButton = jQuery('.backToTop'),
        $newsletter = $('.newsletter-wrap'),
        newsletter_status = 1,
        cookie_status = getCookie('newsletter');


    if (cookie_status == 'disabled') {
      newsletter_status = 0;
    }

    // Shows the "Subscribe to our newsletter" toast 
    setTimeout(function() {
        if (newsletter_status === 1) {
          $newsletter.fadeIn();
        }
    }, 2000);

    // hide or show the "back to top" button
    jQuery(window).scroll(function() {
        var $this = jQuery(this);

        if ($this.scrollTop() > 200) {
            $scrollTopButton.removeClass('hidden');
        } else {
            $scrollTopButton.addClass('hidden');
        }
    });

    // smooth scroll to top
    $scrollTopButton.on('click', function(event) {
      event.preventDefault();
      jQuery('body,html').animate({
        scrollTop: 0
      }, 700);
    });



    // smooth scroll to top
    $('.close-newsletter').on('click', function(event) {
      $newsletter.fadeOut();
      newsletter_status = 0;
      setCookie('newsletter', 'disabled', 365);
    });
    $('.forced-close').on('click', function(event) {
      setCookie('newsletter', 'disabled', 365);
      $newsletter.fadeOut();
    });
    $(document).on("gform_confirmation_loaded", function (e, form_id) {
      $('.newsletter-wrap .sub-title').remove();
      $('.newsletter-wrap .privacy').remove();
    });
  })(jQuery);

  // Sidr Menu init
  $('#nav-toggle').sidr({
    name: 'sidr-right', //name it
    side: 'right', //position it
    source: '.genesis-nav-menu',
    renaming: false,
    onOpen: function() {
      $('#nav-toggle').addClass('is-active');
    },
    onClose: function() {
      $('#nav-toggle').removeClass('is-active');
    }
  });
});

jQuery(document).ready(function($) {

  if (localStorage.getItem('referer') !== null) {
    var referer = localStorage.getItem('referer');

    if (referer == 'navigation') {
      $('html, body').animate({
           scrollTop: $("#genesis-content").offset().top
       }, 1000);
    }
  }
  localStorage.removeItem('referer');
  window.setTimeout(function() {
    //var iframe = $(".rapid_pay iframe").contents();
    $(".rapid_pay iframe").load( function () {
        $('this').contents().find(".checkout-outer").css("min-height", "auto");
    });
  }, 2000);

  var panelHeight;
  if($('.contact-us .slide-btn').length == 1) {
    panelHeight = 40;
  } else if($('.contact-us .slide-btn').length == 2) {
    panelHeight = 80;
  }
  $('.contact-us.hidden').css('bottom', '-' + (panelHeight) + 'px');
  $('.contact-us').click(function() {
    if($(this).hasClass('hidden')) {
      $(this).css('bottom', '0');
    } else {
        $(this).css('bottom', '-' + (panelHeight) + 'px');
    }
    $(this).toggleClass('hidden');
  })

  $('#preloader').css('width', $('#genesis-content').width() + 'px');

  // Add parameter do URL address on menu click

  $('.mobile-view .menu a').on('click', function(e) {
    localStorage.setItem('referer', 'navigation');
  });

  $('.movile-view .site-title a').on('click', function() {
    localStorage.setItem('referer', 'logo');
  })
})


/**
 *  Rapidpay Script
 * 
 *  @link WP-765
 *  @link html/rp/rp.js   previous path
 */
var rapid_pay_link = {
  'au': 'rapidpay.com.au',
  'uk': 'rapidpay.co.uk',
  'us': 'rapidpay.us',
};

var rapid_pay_iframe = document.querySelector("iframe[src*='" + rapid_pay_link[LEAP.region] + "/home?']");

if (rapid_pay_iframe !== null)
{
    rapid_pay_iframe.style.display = "none";

    (function (mainUrlSearch) 
    {
        document.addEventListener("DOMContentLoaded", function(event)
        {
            var first_iframe = document.querySelector("iframe[src*='" + rapid_pay_link[LEAP.region] + "/home?']");

            if(mainUrlSearch && mainUrlSearch.indexOf('rn=') !== -1)
            {
                var new_iframe = first_iframe.cloneNode(false);

                new_iframe.src = 'https://www.' + rapid_pay_link[LEAP.region] + '/paynow/ext' + mainUrlSearch;
                new_iframe.style.display = "block";

                first_iframe.parentNode.appendChild(new_iframe);

                first_iframe.remove();
            }

            else
            {
                first_iframe.style.display = "block";
            }
        });
        
    })(window.location.search)
}